module.exports = __webpack_public_path__ + "static/improve_report-7baa460f913fadf7fc15fbd0f39b0213.jpg";